import React from 'react';
import Icon from '../../Icon/components/Icon';

const SubtitleIcon = (props) => {
  return (
    <Icon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <line x1="4" y1="6" x2="20" y2="6"/>
      <line x1="4" y1="12" x2="20" y2="12" strokeWidth="3"/>
      <line x1="4" y1="18" x2="20" y2="18"/>
    </Icon>
  );
};

export default SubtitleIcon;
